import { isMobile } from '../../util';

const CheckoutBanner = ({
    accountId, sourceId, retailerId, placementId
}) => {
    return (
        <div className='surfside-menu-banner'>
            <div
                className='surf-ad-placement'
                accountid={accountId}
                channelid='bf9bc'
                siteid={sourceId}
                placementid={placementId}
                storeid={retailerId}
                keywords='checkout'
                zone='checkout'
                type='inline'
                adtypes='0,1'
                width={isMobile() ? "4" : "8"}
                height={1}
            >
            </div>
        </div>
    );
};

export default CheckoutBanner;
